module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/close-medium-a614bf98b49a392dac85745f444a174b.svg";